import { cssVar } from 'utils/css';

export const baseline = {
  '@global': {
    body: {
      backgroundColor: cssVar('--body-background'),
      color: cssVar('--color-mako'),
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: '1.6',
      minWidth: '20rem',
    },
  },
};
